import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const ModalFooter = ({ variant = 'default', dense = false, className, children, ...props })=>jsx("div", {
        className: classNames('cb-modal-footer', {
            padded: !dense
        }, variant, className),
        "data-testid": "modal-footer",
        ...props,
        children: children
    });
ModalFooter.displayName = 'Modal.Footer';

export { ModalFooter };
//# sourceMappingURL=Modal.Footer.es.js.map
